export default {"src":"/_next/static/media/contentsOutline100_40.a5a37a4c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};